// extracted by mini-css-extract-plugin
export default {"container":"RegisterPage_container__CnWOs","reminder":"RegisterPage_reminder__MA7r9","errorBox":"RegisterPage_errorBox__ElBzd","disabledButton":"RegisterPage_disabledButton__JEXoV"};